var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qm-description",class:{'form-item': _vm.formItem, slim: _vm.slim},style:(_vm.computedStyle)},[_c('img',{staticClass:"qm-description-icon",style:({visibility: _vm.noIcon ? 'hidden' : 'visible'}),attrs:{"src":"/static/icon/icon-notice-info.svg","alt":""}}),_c('div',{staticClass:"qm-description-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }